import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const martialItems = [
  '15º Dan de Artes Marciales Japonesas Bujinkan Dojo, expedido por el Soke Masaaki Hatsumi en Japón.',
  'Discípulo directo del Maestro Pedro Fleitas.',
  'Título de Dai Shihan (Maestro de Maestros) por el Soke Masaaki Hatsumi en Japón.',
  'Medalla de Honor de Bujinkan Dojo Japón.',
  'Título Shin Gi Tai por méritos a la perseverancia en Japón.',
  'Instructor Senior de la Shidoshi Kai japonesa (Asociación de Instructores).',
  'Título de Zen Dai Shihan de Bujinkan Unryūkai (Proyecto Unryūkai).',
  '3er Dan de Sambo Defensa Personal Bujinkan (Federación Española de Lucha).',
  'Entrenador Nacional de Sambo Defensa Personal Bujinkan (Federación Española de Lucha).',
  'Profesor del SUP (Sindicato de Policía) de la Policía Nacional.',
  'Formador en Defensa Personal para empresas de Seguridad Privada.'
];

const therapiesItems = [
  'Acupuntor',
  'Osteópata',
  'Quiromasajista',
  'Técnicas tibetanas',
  'Técnica cráneo-sacral',
  'Naturópata',
  'Suplementación Natural',
  'Fitoterapia (Plantas Medicinales)',
  'Amatsu Tatara',
  'Terapeuta en Hipnosis Aplicada',
  'Anma (masaje tradicional japonés)',
  'Seitai (osteopatía tradicional japonesa)',
  'Ampuku (técnica abdominal japonesa)',
  'Vendaje Neuromuscular (Kinesiotape)',
  'Kinesiólogo',
  'Moxibustión',
  'Ventosas'
];

const RichardSection = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="richard" className="py-28">
      <div className="container mx-auto px-6">
        <div className="mb-12 max-w-2xl">
          <h2 className="mb-4 text-xs font-bold uppercase tracking-[0.5em] text-emerald-600">Director</h2>
          <h3 className="text-5xl font-black leading-tight tracking-tighter text-slate-900">Richard Atik</h3>
        </div>

        <div className="mx-auto max-w-3xl rounded-[2rem] border border-slate-100 bg-white p-8 shadow-sm md:p-12">
          <p className="mb-4 leading-relaxed text-slate-600">
            Richard Atik es Dai Shihan (Instructor de Instructores) de Bujinkan Dojo, discípulo directo del Maestro
            Pedro Fleitas en Telde. Entrena semanalmente con él y ha realizado más de 45 viajes a Japón desde 1996
            para entrenar bajo la guía del Gran Maestro Soke Masaaki Hatsumi.
          </p>
          <p className="leading-relaxed text-slate-600">
            También imparte seminarios en diferentes lugares y ha desarrollado cursos para empresas de seguridad
            privada y fuerzas de seguridad del Estado. Paralelamente, distribuye su agenda entre consulta de terapias
            y clases de diferentes disciplinas.
          </p>

          {open && (
            <div className="mt-8 space-y-8 border-t border-slate-100 pt-8">
              <div>
                <h4 className="mb-4 text-lg font-black text-slate-900">Como artista marcial</h4>
                <ul className="list-disc space-y-2 pl-5 text-slate-600">
                  {martialItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="mb-4 text-lg font-black text-slate-900">Como terapeuta</h4>
                <ul className="list-disc columns-1 gap-6 pl-5 text-slate-600 md:columns-2">
                  {therapiesItems.map((item) => (
                    <li key={item} className="mb-2 break-inside-avoid">{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="mt-8 flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-slate-200 py-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-800 transition-colors hover:border-emerald-600 hover:text-emerald-700"
          >
            {open ? 'Ver menos' : 'Ver trayectoria completa'}
            <ChevronDown size={18} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default RichardSection;
